export default __webpack_public_path__ + "static/media/i-button-logo.c592d2f8.svg";